import 'videojs-errors';

import { IApplicationData } from 'src/interfaces/ApplicationData';
import { IMarkerService } from 'src/interfaces/MarkerService';
import VideoJsPlayerFactory from 'src/core/player/factories/VideoJsPlayerFactory';
import Player from 'src/core/player/entities/Player';
import MarkerServiceV1 from '../MarkerService/MarkerServiceV1';
import ProgressService from '../ProgressService';
import DatahubService from '../DatahubService';
import MessageEventService from '../MessageEventService';
import UserPreferencesService from '../UserPreferencesService';
import MarkerServiceV2 from '../MarkerService/MarkerServiceV2';
import SubtitleService from '../SubtitleService';
import CustomerFeedbackService from '../CustomerFeedbackService';

class ApplicationService {
  public applicationData: Readonly<IApplicationData>;

  public datahub: DatahubService;
  public userPreferences: UserPreferencesService;
  public marker: IMarkerService;

  public player?: Player;
  public progress?: ProgressService;
  public messageEvent?: MessageEventService;
  public subtitle: SubtitleService;
  public csat: CustomerFeedbackService;

  init(applicationData: IApplicationData) {
    this.applicationData = applicationData as IApplicationData;
    this.userPreferences = new UserPreferencesService(applicationData);

    if (applicationData.isJwtSignature) this.marker = new MarkerServiceV2(applicationData);
    else this.marker = new MarkerServiceV1(applicationData);
  }

  get isDRMEnabled() {
    return this.applicationData.isDrmEnabled;
  }

  async setPlayer(videoElement: HTMLVideoElement, callback?: () => void) {
    const { applicationData } = this;

    this.player = this.createPlayer(videoElement, callback);
    this.datahub = new DatahubService(applicationData, this.player);
    this.progress = new ProgressService(applicationData, this.player);
    this.messageEvent = new MessageEventService(applicationData, this.player);
    this.csat = new CustomerFeedbackService(applicationData);
    this.subtitle = new SubtitleService(this.player);
    if (this.isDRMEnabled) await this.player?.enableDRM();
  }

  private createPlayer(player: HTMLVideoElement, callback?: () => void) {
    const { applicationData } = this;

    const playerFactory = new VideoJsPlayerFactory(applicationData);
    return playerFactory.createPlayer(applicationData.transmissionType, player, callback);
  }

  clean() {
    this.player?.clean();
    this.player = undefined;
  }
}

export default new ApplicationService();
